var a = function a(e, t) {
    var h = Math.max(0, Math.min(e.x + e.width, t.x + t.width) - Math.max(e.x, t.x)),
      n = Math.max(0, Math.min(e.y + e.height, t.y + t.height) - Math.max(e.y, t.y));
    return h * n;
  },
  r = function r(e) {
    var t = e.getBoundingClientRect(),
      h = {
        x: t.x,
        y: t.y,
        width: t.width,
        height: t.height
      },
      n = {
        x: 0,
        y: 0,
        width: window.innerWidth,
        height: window.innerHeight
      },
      c = h.width * h.height;
    return a(h, n) / c;
  },
  x = function x(_ref) {
    var e = _ref.element,
      _ref$percentVisible = _ref.percentVisible,
      t = _ref$percentVisible === void 0 ? 100 : _ref$percentVisible;
    if (!e) return !1;
    var h = r(e) * 100;
    return Number.isNaN(h) ? !0 : t <= h;
  };
export { x as checkInViewport };